import { IAllowedActionScope, IChangeDescriptionActionScope, IChangeOwnerActionScope, IDeleteActionScope, IGetUserUrlScope } from '../../app/ActionPlaceScopes';
import { getAppStore } from '../../app/AppStore';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { DetailsDialogInAngularPlaceHelper, IDetailsDialogInAngularPlaceHelper } from '../../app/spaces/DetailsDialog/AngularContentDetailsDialog';
import { Location } from '../../common/react/Location';
import { ActionContext } from '../helpers/ActionContext';
import { IProjectDetailInfo } from '../models/IProjectInfo';
import { IUserInfo } from '../models/IUserInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { IProjectActions } from '../ServerApi/types/IProjectActions';
import { ChangeProjectDescriptionAction } from '../services/ChangeProjectDescriptionAction';
import { ContentActions, ContentActionsService } from '../../commonInfra/contentActions/ContentActions';
import { ToasterService } from '../services/ToasterService';

export interface IProjectDetailsDialogScope extends
  IAllowedActionScope<IProjectActions>,
  IDeleteActionScope,
  IChangeDescriptionActionScope,
  IChangeOwnerActionScope,
  IGetUserUrlScope
{
  project: IProjectDetailInfo;
}


export class ProjectDetailsDialogCtrl {
  public static $inject = [
    '$scope',
    'projectDetailInfo',
    'projectActions',
    'ChangeProjectDescriptionAction',
    'detailsDialogHelper'
  ];

  constructor(
            $scope: IProjectDetailsDialogScope,
            projectDetailInfo: IProjectDetailInfo,
            projectActions: IProjectActions,
            ChangeProjectDescriptionAction: ChangeProjectDescriptionAction,
            detailsDialogHelper: DetailsDialogInAngularPlaceHelper
  ) {
    this.initNecessaryScopePropertiesForDetailsDialog($scope, projectDetailInfo, projectActions, ChangeProjectDescriptionAction, ContentActionsService, detailsDialogHelper, ToasterService.instance);
  }

  private initNecessaryScopePropertiesForDetailsDialog(
      $scope: IProjectDetailsDialogScope,
      projectDetailInfo: IProjectDetailInfo,
      projectActions: IProjectActions,
      ChangeProjectDescriptionAction: ChangeProjectDescriptionAction,
      ContentActions: ContentActions,
      dialogHelper: IDetailsDialogInAngularPlaceHelper,
      toaster: ToasterService
  ) {

    $scope.project = projectDetailInfo;

    $scope.allowedAction = (actionName: keyof IProjectActions) => (!!projectActions && projectActions[actionName]);

    $scope.del = ($event: JQueryEventObject) => {
      ContentActions.deleteProject(projectDetailInfo, ActionContext.fromEvent($event))
      .then(() => {
        toaster.markToastsAsDoNotDismissOnLocationChange();
        const siteUrls = siteUrlsSelector(getAppStore().getState());

        if (projectDetailInfo.parentId) {
          Location.instance.setUrl(siteUrls.projectUrl(projectDetailInfo.parentId));
        } else {
          Location.instance.setUrl(siteUrls.projectsUrl());
        }
      });
    };

    $scope.changeDescription = (newDescription: string) => {
      return ChangeProjectDescriptionAction.execute(projectDetailInfo, newDescription)
        .then(dialogHelper.inlineEditResultHandler);
    };

    $scope.changeOwner = ($event: JQueryEventObject) => {
      const projectSet = Set.singletonForIdItem(projectDetailInfo);
      const actionContext = ActionContext.fromEvent($event);
      return ContentActions.changeOwnerOnProjects(projectSet, actionContext)
        .then(dialogHelper.actionFromSeparateDialogResultHandler);
    };

    $scope.getUserUrl = (user: IUserInfo): string => {
      const siteUrls = siteUrlsSelector(getAppStore().getState());
      return siteUrls.userUrl(user.username, user.domainName);
    };
  }
}

Module.instance().controller('ProjectDetailsDialogCtrl', ProjectDetailsDialogCtrl);
